import Text from './Text.vue';
import Range from './Range.vue';
import Duration from './Duration.vue';
import Datetime from './Datetime.vue';
import Dropdown from './Dropdown.vue';
import LineGroup from './LineGroup.vue';
import Boolean from './Boolean.vue';
import Tags from './Tags.vue';

export { default as Text, type Options as TextOptions } from './Text.vue';
export { default as Range, type Options as RangeOptions } from './Range.vue';
export { default as Duration, type Options as DurationOptions } from './Duration.vue';
export { default as Datetime, type Options as DatetimeOptions } from './Datetime.vue';
export { default as Dropdown, type Options as DropdownOptions } from './Dropdown.vue';
export { default as Tags, type Options as TagsOptions } from './Dropdown.vue';
export { default as LineGroup, type Options as LineGroupOptions } from './LineGroup.vue';
export { default as Boolean, type Options as BooleanOptions } from './Boolean.vue';

export type FilterType = 'linegroup' | 'text' | 'dropdown' | 'range' | 'duration' | 'datetime' | 'bool' | 'tags';

const mapping = {
  text: Text,
  range: Range,
  duration: Duration,
  datetime: Datetime,
  tags: Tags,
  dropdown: Dropdown,
  linegroup: LineGroup,
  bool: Boolean,
};

export default mapping;
